import React from 'react'
import { Flex, Box, Grid } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'

const DottedSeparator = () => {
  return (
    <Box
      height="50%"
      borderTopWidth="small"
      borderTopStyle="dashed"
      borderTopColor="gray60"
      alignSelf="flex-end"
    />
  )
}

export type Props = {
  redactedNum: number
}

const RedactedUsers: React.FC<Props> = ({ redactedNum }) => {
  return (
    <Grid
      gridTemplateColumns="1fr auto 1fr"
      data-testid="leaderboard-separator"
    >
      <DottedSeparator />
      <Flex justifyContent="center" as="p" variant="text.subtitle" mx="1x">
        {t(
          '%{smart_count} user not shown |||| %{smart_count} users not shown',
          { smart_count: redactedNum }
        )}
      </Flex>
      <DottedSeparator />
    </Grid>
  )
}

export default RedactedUsers
